import {Injectable, TemplateRef} from '@angular/core';
import {ComponentType} from '@angular/cdk/overlay';
import {MatDialog} from '@angular/material/dialog';
import {MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {SnackService} from '../snack/snack.service';
import {Subject} from 'rxjs';

@Injectable()
export class DialogService {
  constructor(private dialog: MatDialog,
              private snackService: SnackService) {}

  private _instances: any = {};
  public scrollTop: number = 0;


  get openDialogs(): MatDialogRef<any>[] {
    return this.dialog.openDialogs;
  };

  get afterOpened(): Subject<MatDialogRef<any>> {
    return this.dialog.afterOpened;
  }

  get isScrolled(): boolean {
    return this.scrollTop > 0;
  }

  public open<T, D = any, R = any>(template: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>, ignoreNotifications?: boolean): MatDialogRef<T, R> {
    const dialogRef = this.dialog.open(template, config);
    const containerInstance = dialogRef.id + '_container', contentInstance = dialogRef.id + '_content'; // container is used for mobiles, content is for desktop
    if (ignoreNotifications) {
      this.snackService.hidden = true;
      this.snackService.clearAll();
    } else {
      this.snackService.hidden = true;
      if (this.snackService.isOpened) {
        this.snackService.hide();
      }
    }
    dialogRef.afterOpened().subscribe(() => {
      this.scrollTop = 0;
      if (!ignoreNotifications) {
        this.snackService.moveToDialog();
      }
      const instance: any = dialogRef?._containerInstance;
      if (instance) {
        const element = instance?._elementRef?.nativeElement;
        if (element) {
          element.addEventListener('scroll', this.scroll);
          this._instances[containerInstance] = element;
          const content = element.querySelector('mat-dialog-content');
          if (content) {
            content.addEventListener('scroll', this.scroll);
            this._instances[contentInstance] = content;
          }
        }
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      if (!this.openDialogs?.length) {
        this.snackService.hidden = false;
      }
      if (this._instances[containerInstance]) {
        this._instances[containerInstance].removeEventListener('scroll', this.scroll);
        delete this._instances[containerInstance];
      }
      if (this._instances[contentInstance]) {
        this._instances[contentInstance].removeEventListener('scroll', this.scroll);
        delete this._instances[contentInstance];
      }
    });
    return dialogRef;
  }

  private scroll($event: Event): void {
    const target: any = $event?.target;
    if (target) {
      this.scrollTop = target.scrollTop;
    }
  }

  public closeAll(): void {
    this.dialog.closeAll();
  }

  public getDialogById(id: string): MatDialogRef<any> | undefined {
    return this.dialog.getDialogById(id);
  }
}
